import * as actionTypes from "./actionTypes";
import {appError, appLoading, appSuccess} from "./appActions";
import {registerAccountApi, validatePhoneApi, validateEmailApi} from "../../api/registerAccountUrl";
import {toastr} from "react-redux-toastr";

export const registerAccountSuccess = (data) => ({
    type: actionTypes.REGISTER_ACCOUNT_SUCCESS,
    payload: data,
})

export const registerAccountError = (error) => ({
    type: actionTypes.REGISTER_ACCOUNT_ERROR,
    payload: error,
})

export const validatePhoneSuccess = (data) => ({
    type: actionTypes.VALIDATE_PHONE_SUCCESS,
    payload: data,
})

export const validatePhoneError = (error) => ({
    type: actionTypes.VALIDATE_PHONE_ERROR,
    payload: error,
})

export const validateEmailPublicSuccesss = (data) => ({
    type: actionTypes.VALIDATE_EMAIL_PUBLIC_SUCCESSS,
    payload: data,
})

export const validateEmailPublicError = (error) => ({
    type: actionTypes.VALIDATE_EMAIL_PUBLIC_ERROR,
    payload: error,
})

export const registerAccount = (payload) => (dispatch) => {
    const { register, history, t } = payload;
    dispatch(appLoading());
    registerAccountApi(register)
        .then((response) => {
            const { data } = response;
            dispatch(appSuccess());
            dispatch(registerAccountSuccess(register));
            toastr.success('INFO', t('endProcess.msgResponse'));
            history.push('/register-success');
        })
        .catch((error) => {
            console.log(error);
            dispatch(appError());
            if (error && error.response && error.response.data) {
                toastr.error('ERROR', error.response.data.description);
                console.log('Error: ', error.response.data.description);
            } else {
                toastr.error('ERROR: ', "error connected to server");
                console.log('Error: ', 'error connected to server');
            }
        });
};

export const validatePhone = (payload) => (dispatch) => {
    const { phoneData, history } = payload;
    dispatch(appLoading());
    validatePhoneApi(phoneData)
        .then((response) => {
            const { data } = response;
            dispatch(appSuccess());
            dispatch(validatePhoneSuccess(data.result));
        })
        .catch((error) => {
            dispatch(appError());
            if (error && error.response && error.response.data) {
                console.log('Error: ', 'No se ha podido validar el teléfono, '+ error.response.data.description);
            } else {
                toastr.error('ERROR: ', "error connected to server");
                console.log('Error: ', 'No se ha podido validar el teléfono. Error connected to server');
            }
        });
};

export const validateEmail = (payload) => (dispatch) => {
    const { emailData, history} = payload;
    dispatch(appLoading());
    validateEmailApi(emailData)
        .then((response) => {
            const { data } = response;
            dispatch(appSuccess());
            dispatch(validateEmailPublicSuccesss(data.result));

        })
        .catch((error) => {
            dispatch(appError());
            dispatch(validateEmailPublicError(error));
            if (error && error.response && error.response.data) {
                console.log('Error: ', 'No se ha podido validar el correo, ' + error.response.data.description);
            } else {
                toastr.error('ERROR: ', "error connected to server");
                console.log('Error: ', 'No se ha podido validar el correo. Error connected to server');
            }
        });
};
